module.exports = __webpack_public_path__ + "static/graphql.9530d6a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/graphql.svg
// module id = 740
// module chunks = 263791100135453